<template>
	<div id="fibre-devices" :class="{hide: !showDevice}">
		<div class="device-toggle">
			<a class="btn" :class="{ 'selected': currentDevice === 'tp-link' }" @click="currentDevice = 'tp-link'">TP-Link deco x50</a>
			<a class="btn" :class="{ 'selected': currentDevice === 'tp-link-ex511' }" @click="currentDevice = 'tp-link-ex511'">TP-Link EX511</a>
		</div>

		<div class="devices">
			<div class="device-type" v-if="currentDevice === 'tp-link'">
				<!--<div class="warning"><span>Temporarily out of stock</span></div> -->
				<div class="device">

						<img :src="`${assetBase}/assets/main/images/devices/2112-TPLink-DecoX50-3pack-hero.png`" :srcset="`${assetBase}/assets/main/images/devices/2112-TPLink-DecoX50-3pack-hero@2x.png 2x`" alt="TP Link"/>
						<div class="items">
							<span class="item-wrap"><span class="icon"><svg><use xlink:href="#download"></use></svg></span> Up to 3000mbps<br class="desktop"/> download speed*</span>
							<span class="item-wrap"><span class="icon"><svg><use xlink:href="#wifi-new"></use></svg></span> Covers up to 603m<sup>2</sup></span>
							<span class="item-wrap"><span class="icon"><svg><use xlink:href="#wifi-6"></use></svg></span> Powered by WiFi6</span>
						</div>


						<div class="titles">
							<span class="title">TP-Link Deco X50</span>
							<span class="sub-title">Mesh WiFi 6 system - ideal for larger homes.</span>
						</div>
						<p class="description">
							Kill WiFi dead zones with the TP-Link Deco X50. The Deco is a mesh WiFi 6 system designed to deliver a huge boost in coverage, speed, and total WiFi capacity throughout your whole house. You can add it to your order during the signup process.
						</p>
						<div class="cta-block">
							<div class="prices">
								<p class="price">R3 999.00 for 2-pack</p>
								<p class="price">R5 999.00 for 3-pack</p>
							</div>
							<a href="http://x20.afrihost.com/" target="_blank" class="btn gradient-red medium"><span>More info</span></a>
						</div>

				</div>
			</div>

			<div class="device-type" v-if="currentDevice === 'tp-link-ex511'">
				<!--<div class="warning"><span>Temporarily out of stock</span></div> -->
				<div class="device">

					<img :src="`${assetBase}/assets/main/images/devices/tp-link-landing-page.png`" :srcset="`${assetBase}/assets/main/images/devices/tp-link-landing-page@2x.png 2x`" alt="TP Link EX511"/>
					<div class="items">
						<span class="item-wrap"><span class="icon"><svg><use xlink:href="#download"></use></svg></span> Speeds up to 3000 Mbps*</span>
						<span class="item-wrap"><span class="icon"><svg><use xlink:href="#locked"></use></svg></span> WPA3 Security</span>
						<span class="item-wrap"><span class="icon"><svg><use xlink:href="#wifi-6"></use></svg></span> Powered by WiFi6</span>
					</div>


					<div class="titles">
						<span class="title">TP-Link EX511</span>
						<span class="sub-title">WiFi 6 Fibre router - included with selected Fibre providers.</span>
					</div>
					<p class="description">
						Blazing-fast Fibre needs a blazing-fast router. The TP-Link EX511 is a WiFi 6 router offering faster speeds, larger capacity, lower latency and less power consumption. Equipped with advanced antennas and Beamforming technology, enjoy extended coverage and reliable connection throughout your home.
					</p>
					<div class="cta-block">
						<div class="prices">

						</div>
						<a href="https://www.afrihost.com/devices/view/tp-link-ex511" target="_blank" class="btn gradient-red medium"><span>More info</span></a>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	data() {
		return {
			currentDevice: "tp-link-ex511"
		}
	},
	computed: {
		assetBase() {
			return window._assetBaseUrl;
		},
		showDevice() {
			return this.$store.getters['general/showRouters']
		}
	}
}
</script>

<style lang="scss" scoped>
	@import "resources/assets/main/scss/setup/variables";
	@import "resources/assets/main/scss/setup/mixins";

	#fibre-devices {
		border: .1rem solid #E0E0E0;
		border-radius: 1rem;
		padding: 2rem;
		background: #fff;

		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;

		&.hide {
			display: none;
			visibility: hidden;
		}
		@include break-point(mobile) {
			border: none;
			padding: 0;
		}

		.device-toggle {
			width: 61.1rem;
			height: 4.6rem;
			border-radius: 2.3rem;
			border: .1rem solid #E0E0E0;
			padding: 0 .4rem;
			margin-bottom: 1rem;

			display: flex;
			justify-content: space-between;
			align-items: center;

			@include break-point(tablet-portrait) {
				width: 100%;
			}

			.btn {
				width: 30rem;
				height: 3.6rem;
				border-radius: 23px;
				background-image: none;
				color: #707372;
				font-size: 1.2rem;
				line-height: 1.2rem;
				font-weight: $font-weight-bold;
				text-transform: uppercase;
				transition: all .2s ease;

				@include break-point(mobile) {
					width: 100% !important;
					padding: 0 1.5rem;
				}

				display: flex;
				justify-content: center;
				align-items: center;

				&.selected {
					width: 30rem;
					height: 3.6rem;
					color: #fff;
					background-image: linear-gradient(180deg, #009CA6 0%, #1D8296 100%);
				}
			}
		}

		.devices {
			border: .1rem solid #E0E0E0;
			border-radius: 1rem;

			.device-type {

				.warning {
					width: 100%;
					height: 6rem;
					max-width: 98rem;
					margin: 0 auto;
					color: #ffffff;
					font-size: 1.6rem;
					line-height: 2.2rem;
					background: #F4AC0D;
					border-radius: 1rem;
					font-weight: $font-weight-bold;

					display: flex;
					align-items: center;
					justify-content: center;
				}

				.device {
					padding: 4rem 4rem 2rem 4rem;
					transition: all .2s ease;

					display: grid;
					grid-template-columns: 1fr 1fr 2fr;
					grid-template-rows: auto auto 1fr;
					grid-template-areas: "header-start header-mid header-end"
										 "content-start content-mid content-end"
										 "footer-start footer-mid footer";

					gap: 1rem;

					@include break-point(tablet-portrait) {
						grid-template-columns: 1fr 1fr;
						grid-template-rows: 7.5rem 4fr 4fr;
						grid-template-areas: ". header-end"
											 "content-start content-end"
											 "items-start items-end";
					}

					@include break-point(mobile) {
						padding: 2rem 2rem;
						grid-template-areas: "header"
											 "title"
											 "description"
											 "items"
						 					 "footer";
						grid-template-columns: 1fr;
						grid-template-rows: repeat(5, max-content);
					}

					img {
						justify-content: start;
						justify-self: center;
						align-self: center;
						grid-area: header-start / content-start / footer-start;

						@include break-point(tablet-landscape) {
							grid-area: content-start;
							place-self: center;
						}

						@include break-point(tablet-portrait) {
							margin-left: -5rem;
							margin-top: -10rem;
						}

						@include break-point(mobile) {
							grid-area: header;
							margin: 0 auto;
						}
					}

					.items {
						margin-left: 2rem;

						display: flex;
						justify-content: center;
						align-items: flex-start;
						flex-direction: column;

						grid-area: header-mid / content-mid / footer-mid;

						sup {
							font-size: 0.7rem;
						}

						@include break-point(tablet-landscape) {
							margin-left: 1rem;
						}

						@include break-point(tablet-portrait) {
							margin-left: 3rem;
							margin-top: -4rem;
							grid-area: items-start;
							justify-content: start;
						}

						@include break-point(mobile) {
							grid-area: items;
							margin-left: 0;
							margin-top: 0;
							place-self: center
						}

						.item-wrap {
							font-size: 1.2rem;
							line-height: 1.8rem;
							font-weight: $font-weight-medium;
							color: #747474;
							text-align: left;
							margin-bottom: 1.5rem;

							display: flex;
							align-items: center;
							justify-content: center;

							.desktop {
								display: block;

								@include break-point(mobile) {
									display: none;
								}
							}

							.icon {
								width: auto;
								height: 3.6rem;
								border-radius: 50%;
								border: .2rem solid #009CA6;
								margin-right: 1rem;
								padding: .9rem;

								display: flex;
								justify-content: center;
								align-items: center;

								svg {
									fill: #009CA6;
								}

							}
						}

						&:nth-of-type(1) {
							.icon {
								svg {
									width: 1.4rem;
									height: 1.9rem;
								}
							}
						}

						&:nth-of-type(2) {
							.icon {
								svg {
									width: 2rem;
									height: 1.6rem;
								}
							}
						}

						&:nth-of-type(3) {
							.icon {
								svg {
									width: 1.2rem;
									height: 2.1rem
								}
							}
						}
					}

					.titles {

						display: grid;
						justify-items: start;
						grid-auto-rows: max-content;
						justify-content: start;
						grid-area: header-end;

						@include break-point(mobile) {
							grid-area: title;
							justify-items: center;
							place-self: center
						}
					}

					.title {
						font-size: 2.2rem;
						line-height: 3.2rem;
						font-weight: $font-weight-bold;
						color: #1D8296;
					}

					.sub-title {
						font-size: 1.6rem;
						line-height: 2.2rem;
						font-weight: $font-weight-medium;
						color: #707372;
						text-align: left;
					}

					.description {
						font-size: 1.2rem;
						line-height: 2.2rem;
						font-weight: $font-weight-book;
						color: #747474;
						text-align: left;
						margin-bottom: 2rem;
						margin-top: 2rem;

						grid-area: content-end;
						justify-content: end;

						@include break-point(tablet-portrait) {
							margin-bottom: 2rem;
						}

						@include break-point(mobile) {
							grid-area: description;
						}
					}

					.title, .sub-title,
					.description {
						@include break-point(mobile) {
							text-align: center;
						}
					}

					.cta-block {
						width: 100%;

						display: flex;
						align-items: center;

						grid-area: footer;
						justify-content: space-between;

						@include break-point(tablet-portrait) {
							flex-direction: column;
							align-items: flex-start;

							grid-area: items-end;
							justify-content: start;
						}

						@include break-point(mobile) {
							grid-area: footer;
						}

						.price {
							font-size: 1.8rem;
							line-height: 2.6rem;
							font-weight: $font-weight-book;
							color: #707372;
							text-align: left;

							@include break-point(tablet-landscape) {
								font-size: 1.4rem;
								line-height: 2.4rem;
							}

							& + .price {
								margin-top: 0.8rem;
							}

							@include break-point(tablet-portrait) {
								margin-bottom: 2rem;
							}

							@include break-point(mobile) {
								display: none;
							}
						}

						.btn {
							width: 16rem;
							height: 4.2rem;
							border-radius: 3rem;
							font-size: 1.2rem;
							line-height: 1.2rem;
							font-weight: $font-weight-bold;

							@include break-point(mobile) {
								width: 100%;
								margin-bottom: 2rem;
							}

							display: flex;
							align-items: center;
							justify-content: center;
						}
					}
				}
			}
		}
	}
</style>
